import type { ApiQuestion } from '../../../../internalTypes';
import { buildSelectableScalePoints } from '../matrix/buildSelectableScalePoints';

export function buildNpsScalePoints(
  question: ApiQuestion,
  language?: string
): { id: string; optionLabel: string }[] {
  return buildSelectableScalePoints(question, language, { defaultCount: 11 });
}
